const FirstDibsToken = require('./build/contracts/FirstDibsToken.json');
const GenericERC721Token = require('./build/contracts/GenericERC721Token.json');
const GenericERC1155Token = require('./build/contracts/GenericERC1155Token.json');
const FirstDibsTokenV2 = require('./build/contracts/FirstDibsTokenV2.json');
const FirstDibsAuction = require('./build/contracts/FirstDibsAuction.json');
const FirstDibsAuctionV2 = require('./build/contracts/FirstDibsAuctionV2.json');
const FirstDibsCreatorRegistry = require('./build/contracts/FirstDibsCreatorRegistry.json');
const FirstDibsMarketSettings = require('./build/contracts/FirstDibsMarketSettings.json');
const FirstDibsMarketSettingsV2 = require('./build/contracts/FirstDibsMarketSettingsV2.json');
const FirstDibsBalances = require('./build/contracts/FirstDibsBalances.json');
const SplitMain = require('./build/contracts/SplitMain.json');
const RoyaltyEngineV1 = require('./build/contracts/RoyaltyEngineV1.json');
const RoyaltyRegistry = require('./build/contracts/RoyaltyRegistry.json');
const FirstDibsMarketV3 = require('./build/contracts/FirstDibsMarketV3.json');
const GenArt721CoreV1 = require('./externalAbi/artblocks/GenArt721CoreV1.json');

module.exports = {
    FirstDibsToken,
    GenericERC721Token,
    GenericERC1155Token,
    FirstDibsTokenV2,
    FirstDibsAuction,
    FirstDibsAuctionV2,
    FirstDibsCreatorRegistry,
    FirstDibsMarketSettings,
    FirstDibsMarketSettingsV2,
    FirstDibsBalances,
    RoyaltyRegistry,
    RoyaltyEngineV1,
    SplitMain,
    GenArt721CoreV1 /* this is artblocks 721 contract */,
    FirstDibsMarketV3,
};
